module.exports = __webpack_public_path__ + "img/add_btn_icon211.60836449.svg";